import { weijuModules } from '@/mocks/weiju';
import Reveal from '@/components/base/Reveal';

export default function BusinessLoop() {
  return (
    <section id="business" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 border border-accent-200 text-xs md:text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              怎么形成业务闭环
            </div>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              六大核心业务，构成完整业务闭环
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              从聚餐社交入口，到餐饮经营、甄选商城、供应链协同、数字权益与平台治理，环环相扣。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {weijuModules.map((mod, idx) => (
            <Reveal key={mod.no} delay={(idx % 2) * 100}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 overflow-hidden flex flex-col">
                <div className="p-6 md:p-7 border-b border-background-200">
                  <div className="flex items-start gap-4">
                    <div className="shrink-0 w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 font-heading font-bold text-lg">
                      {mod.no}
                    </div>
                    <div>
                      <h3 className="font-heading font-bold text-xl text-foreground-950">{mod.title}</h3>
                      <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{mod.subtitle}</p>
                    </div>
                  </div>
                </div>

                <div className="p-6 md:p-7 flex-1 flex flex-col gap-5">
                  <div>
                    <h4 className="text-xs font-semibold tracking-widest text-foreground-500 uppercase">业务链路</h4>
                    <div className="mt-2 flex flex-wrap gap-1.5">
                      {mod.flow.map((step, i) => (
                        <span key={step} className="inline-flex items-center gap-1">
                          <span className="px-2.5 py-1 rounded-md bg-background-100 text-foreground-700 text-xs whitespace-nowrap">
                            {step}
                          </span>
                          {i < mod.flow.length - 1 && (
                            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <h4 className="text-xs font-semibold tracking-widest text-foreground-500 uppercase">覆盖内容</h4>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {mod.points.map((p) => (
                        <span key={p} className="px-3 py-1 text-xs rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                          {p}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="mt-auto pt-4 border-t border-background-200">
                    <div className="flex items-start gap-2">
                      <i className="ri-lightbulb-flash-line text-secondary-600 mt-0.5"></i>
                      <p className="text-sm text-foreground-700 leading-relaxed">
                        <span className="font-semibold text-foreground-900">核心价值：</span>
                        {mod.value}
                      </p>
                    </div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}